const locales = JSON.parse('[{"value":"uk","name":"UA"},{"value":"ru","name":"RU"}]')

export default locales
